<template>
    <van-overlay :show="applyShow">
        <div class="apply-overlay-box">
            <div class="apply-overlay-box-wrap">
                <div class="apply-overlay-box-wrap-bg">
                    <img src="/static/v4/pic_tip_success_bg.svg" />
                </div>
                <div class="apply-overlay-box-wrap-close">
                    <img src="/static/v4/icon_tip_close.svg" alt="" @click="applyShow = false" />
                </div>
                <div class="apply-overlay-box-wrap-title">
                    <span>预约成功提醒</span>
                </div>
                <div class="apply-overlay-box-wrap-content">
                    您已成功预约本次直播，开播前将收到短信提醒。您也可在 <span>“我的”-“我的预约”</span> 中查看您的预约情况。
                </div>
                <div class="apply-overlay-box-wrap-img">
                    <img src="/static/v4/code.jpg" />
                </div>
            </div>
        </div>
    </van-overlay>
</template>

<script>
import Interface from '@/util/interface'

export default {
    data() {
        return {
            applyShow: false
        }
    },
    props: {
        dataItem: {
            type: Object
        }
    },
    watch: {
        applyShow: {
            handler(newValue) {
                if (newValue) {
                    document.body.style.overflow = 'hidden'
                } else {
                    document.body.style.overflow = 'auto'
                    // Interface.goLiveDetail(this, this.dataItem)
                    this.$router.push({ name: 'live-detail-home', params: { id: this.dataItem.id } })
                }
            }
        }
    },
    methods: {
        go_detail(item) {
            Interface.goLiveDetail(this, item)
        }
    }
}
</script>

<style lang="scss" scoped>
.van-overlay {
    z-index: 100;
}
.apply-overlay-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 327px;
    height: 380px;
    background: #ffffff;
    border-radius: 12px;
    &-wrap {
        position: relative;
        &-bg {
            position: absolute;
            left: 0;
            top: 0;
        }
        &-close {
            text-align: right;
            padding-right: 16px;
            img {
                margin-top: 16px;
                width: 15px;
                height: 15px;
            }
        }
        &-title {
            text-align: center;
            span {
                font-size: 17px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #222222;
            }
        }
        &-content {
            margin-top: 14px;
            padding: 0 28px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            text-align: justify;
            line-height: 22px;
            span {
                color: #222;
                margin: 0 5px;
            }
        }
        &-img {
            margin-top: 50px;
            text-align: center;
            img {
                width: 140px;
                height: 140px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/live/list/overlay.vue